/**
 * Paths that must not be indexed (private panels, auth, editors).
 * Used by SSR shell injection and client useSEO guard.
 */

export type NoIndexRouteMeta = {
  title: string;
  description: string;
};

const DEFAULT_DESC = 'Área privada de Statemia.';

/** Exact pathnames (no trailing slash). */
const EXACT: Record<string, NoIndexRouteMeta> = {
  '/login': {
    title: 'Iniciar sesión | Statemia',
    description: 'Accede a tu cuenta de Statemia.',
  },
  '/verify-email': {
    title: 'Verificar email | Statemia',
    description: DEFAULT_DESC,
  },
  '/favorites': {
    title: 'Favoritos | Statemia',
    description: DEFAULT_DESC,
  },
  '/analytics': {
    title: 'Analytics | Statemia',
    description: DEFAULT_DESC,
  },
  '/home': {
    title: 'Inicio | Statemia',
    description: DEFAULT_DESC,
  },
  '/dashboard': {
    title: 'Panel | Statemia',
    description: DEFAULT_DESC,
  },
  '/profile': {
    title: 'Perfil | Statemia',
    description: DEFAULT_DESC,
  },
  '/subscribe': {
    title: 'Suscripción | Statemia',
    description: DEFAULT_DESC,
  },
  '/authentemia': {
    title: 'Authentemia | Statemia',
    description: DEFAULT_DESC,
  },
  '/statistics': {
    title: 'Editor | Statemia',
    description: DEFAULT_DESC,
  },
  '/test-stripe': {
    title: 'Test | Statemia',
    description: DEFAULT_DESC,
  },
};

const PREFIXES: Array<{ prefix: string; meta: NoIndexRouteMeta }> = [
  {
    prefix: '/admin',
    meta: { title: 'Admin | Statemia', description: DEFAULT_DESC },
  },
  {
    prefix: '/statistics/edit',
    meta: { title: 'Editor | Statemia', description: DEFAULT_DESC },
  },
];

/** Normalize path: strip query/hash, trailing slash (except root). */
export function normalizePathname(pathOrUrl: string): string {
  const raw = pathOrUrl.split('?')[0].split('#')[0] || '/';
  if (raw.length > 1 && raw.endsWith('/')) return raw.slice(0, -1);
  return raw || '/';
}

export function getNoIndexRouteMeta(pathOrUrl: string): NoIndexRouteMeta | null {
  const pathname = normalizePathname(pathOrUrl);
  if (EXACT[pathname]) return EXACT[pathname];
  for (const { prefix, meta } of PREFIXES) {
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) return meta;
  }
  return null;
}

export function isNoIndexPath(pathOrUrl: string): boolean {
  return getNoIndexRouteMeta(pathOrUrl) !== null;
}
